module.exports = __webpack_public_path__ + "static/img/img13.a2b75c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/img13.png
// module id = xydS
// module chunks = 1